import { useState } from 'react';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import { Lesson } from '../../../types/lesson.type';
import ClassDetailsCalendar from './ClassDetailsCalendar';
import ClassPreview from './ClassPreview';

const EventKeys = () => {
  return (
    <div
      className="px-lg-3 py-lg-2 mt-3 p-2"
      style={{ width: 'fit-content' }}
    >
      <span
        className="fw-semibold"
        style={{ color: '#5E646980' }}
      >
        Key
      </span>
      <Row className="align-items-center">
        <Col
          xs={12}
          lg="auto"
          className="d-flex align-items-center me-4"
        >
          <div
            className="rounded-circle me-1"
            style={{ width: 8, height: 8, background: '#B4C634' }}
          ></div>
          <span> Class Scheduled</span>
        </Col>
        <Col
          xs={12}
          lg="auto"
          className="d-flex align-items-center me-4"
        >
          <div
            className="rounded-circle me-1"
            style={{ width: 8, height: 8, background: '#B81F69' }}
          ></div>
          <span> No Class</span>
        </Col>
      </Row>
    </div>
  );
};

interface ClassCalendarCardProps {
  dateChange: ({ start, end }: { start: string; end: string }) => void;
  lessons: Lesson[] | undefined;
  isLoading?: boolean;
  onLessonsSelected?: (lessons: Lesson[]) => void;
}

const ClassCalendarCard: React.FC<ClassCalendarCardProps> = ({ dateChange, lessons, isLoading, onLessonsSelected }) => {
  const [selectedLessons, setSelectedLessons] = useState<Lesson[]>([]);
  const selectedDate = (date: string) => {
    if (lessons && lessons.length > 0) {
      const matches = lessons.filter((l) => l.date === date);
      setSelectedLessons(matches);
      onLessonsSelected?.(matches);
    } else {
      setSelectedLessons([]);
      onLessonsSelected?.([]);
    }
  };
  return (
      <Card className="mb-3 mt-4 shadow">
        <Card.Body>
          <Row>
            <Col lg={7} sm={12} className="p-3" style={{ position: 'relative' }}>
              {isLoading && (
                  <div
                      style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'rgba(255, 255, 255, 0.7)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                        borderRadius: '0.375rem'
                      }}
                  >
                    <Spinner animation="border" variant="primary" />
                  </div>
              )}
            <ClassDetailsCalendar
                dateChange={dateChange}
                lessons={lessons}
                selectedDate={selectedDate}
                selectedLesson={selectedLessons[0] ?? null}  // calendar still highlights one
            />
            <EventKeys />
          </Col>
          <Col
            lg={5}
            sm={12}
            className="p-3"
          >
            {selectedLessons.length === 0 && (
                <Card.Text style={{ color: '#5E646980', fontWeight: 600, fontSize: '16px' }}>
                  Select a date to view class details and recipes for that day!
                </Card.Text>
            )}
            <ClassPreview selectedLessons={selectedLessons} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ClassCalendarCard;
